module.exports = __webpack_public_path__ + "img/details_top03.1bdfe239.png";